<section class="space-y-6">
  <div class="flex items-center justify-between">
    <div>
      <h2 class="text-2xl font-semibold text-slate-900">Customers</h2>
      <p class="text-sm text-slate-500">Voucher usage and linked accounts.</p>
    </div>
  </div>

  <div class="rounded-xl border border-slate-200 bg-white shadow-sm">
    <div class="overflow-x-auto">
      <table class="min-w-full text-left text-sm">
        <thead class="bg-slate-50 text-xs font-semibold uppercase tracking-wide text-slate-500">
          <tr>
            <th class="px-6 py-4">Name</th>
            <th class="px-6 py-4">Voucher</th>
            <th class="px-6 py-4">Total Vouchers</th>
            <th class="px-6 py-4">Used</th>
            <th class="px-6 py-4">Remaining</th>
<!--            <th class="px-6 py-4">Accounts Linked</th>-->
            <th class="px-6 py-4"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100">
          @for (customer of customers(); track customer.voucher) {
            <tr class="text-slate-700">
              <td class="px-6 py-5 font-medium text-slate-900">{{ customer.name }}</td>
              <td class="px-6 py-5">{{ customer.voucher }}</td>
              <td class="px-6 py-5">{{ customer.vouchersBought }}</td>
              <td class="px-6 py-5">{{ customer.vouchersBought - customer.usesLeft }}</td>
              <td class="px-6 py-5">{{ customer.usesLeft }}</td>
<!--              <td class="px-6 py-5">{{ customer.accountsUsingCode.length }}</td>-->
              <td class="px-6 py-5">
                <div class="flex items-center justify-end gap-2">
                  <input
                    #voucherQty
                    type="text"
                    placeholder="Qty"
                    class="w-28 rounded-md border border-slate-200 px-3 py-2 text-sm text-slate-700 focus:border-blue-400 focus:outline-none"
                  />
                  <button (click)="addVouchers(customer, voucherQty.value)"
                          class="flex items-center justify-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
                          [disabled]="isAddingVouchers()">
                    @if (isAddingVouchers()) {
                      <span class="material-icons animate-spin text-white">autorenew</span>
                      Adding Vouchers...
                    } @else {
                      Add Vouchers
                    }
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 px-6 py-4 text-xs text-slate-500">
      <button
        class="rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
        type="button"
        (click)="openCreateModal()"
      >
        New Customer
      </button>
      <div class="flex items-center gap-4">
        <div>
          Records Found: {{ totalRecords() }}
        </div>
        <div class="flex items-center gap-2">
          <button
            class="rounded-md border border-slate-200 px-3 py-1 text-xs text-slate-600 disabled:cursor-not-allowed disabled:opacity-50"
            (click)="goToPage(page() - 1)"
            [disabled]="page() === 1"
          >
            Previous
          </button>
          <span class="text-xs text-slate-600">
            Page {{ page() }} of {{ totalPages() }}
          </span>
          <button
            class="rounded-md border border-slate-200 px-3 py-1 text-xs text-slate-600 disabled:cursor-not-allowed disabled:opacity-50"
            (click)="goToPage(page() + 1)"
            [disabled]="page() === totalPages()"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

@if (isCreateOpen()) {
  <app-create-customer-modal
    (closed)="closeCreateModal()"
    (saved)="handleCustomerSaved()"
  ></app-create-customer-modal>
}
